import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { Inventory } from '../../../../entities/Inventory';
import { RiListRadio } from 'react-icons/ri';
const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
 
const initialState = {
    cart: [],
    tabIndex:null,
};

const cartSlice = createSlice({
    name: 'cartSpace',
    initialState,
    reducers: {
        addToCart(state, action) {
            const newInventory = action.payload;
            const inventoryEntity = new Inventory(
                newInventory._id,
                newInventory.locations,
                newInventory.Illu,
                newInventory.width,
                newInventory.height,
                newInventory.CodeNo,
                newInventory.CASCode,
                newInventory.typeOfMedia,
                newInventory.img,
                newInventory.vendor,
                newInventory.ratePerMonth,
                newInventory?.maintenanceRate,
                newInventory.Bookings,
                newInventory.lat,
                newInventory.lng,
                newInventory.startDate,
                newInventory.endDate,
                newInventory.blocked,
                newInventory.blockedFor,
                newInventory.blockedAt,
                newInventory.blockedTill,
                newInventory?.unit,
                newInventory?.isTrading,
                newInventory?.Availability,
                newInventory?.focBookings,
                newInventory?.half1Id,
                newInventory?.half2Id,
                newInventory?.fullId,
                newInventory?.blockedDates,
                newInventory?.premiumBlock,
                newInventory?.isArchived,
                newInventory?.removedOn
            );
            state.cart.push(inventoryEntity);

        },
        addToCartInBulk(state,action){
              let newInventories = action.payload;
              state.cart = [];
              newInventories.map(ele=>{
                let inventoryEntity = new Inventory(
                    ele._id,
                    ele.locations,
                    ele.Illu,
                    ele.width,
                    ele.height,
                    ele.CodeNo,
                    ele.CASCode,
                    ele.typeOfMedia,
                    ele.img,
                    ele.vendor,
                    ele.ratePerMonth,
                    ele?.maintenanceRate,
                    ele.Bookings,
                    ele.lat,
                    ele.lng,
                    ele.startDate,
                    ele.endDate,
                    ele.blocked,
                    ele.blockedFor,
                    ele.blockedAt,
                    ele.blockedTill,
                    ele?.unit,
                    ele?.isTrading,
                    ele?.Availability, 
                    ele?.focBookings,
                    ele?.half1Id,
                    ele?.half2Id,
                    ele?.fullId,
                    ele?.blockedDates,
                    ele?.premiumBlock,
                    ele?.isArchived,
                    ele?.removedOn
                );
                state.cart.push(inventoryEntity);
              })
        },
        removeCartInventory(state,action){
            let id = action.payload;
            state.cart = state.cart.filter(ele=>ele._id!==id)
        },
        resetCart(state){
            state.cart = [];
        },
        removeFromCart(state,action){
            state.cart = state.cart.filter(ele=>ele.locations.name!=action.payload);
        },
        updateCart(state,action){
            let ids = state.cart.map(ele=>{
                return ele._id
            })
        },
        changeIndex(state,action){
            state.tabIndex = action.payload;
        }
    },
});

// Export action creators
export const {
    addToCart,
    addToCartInBulk,
    resetCart,
    removeFromCart,
    removeCartInventory,
    changeIndex
} = cartSlice.actions;

// Reducer
export default cartSlice.reducer;

export const updateCartData = createAsyncThunk(
    'cartSpace/updateCartData',
    async (_, { dispatch, getState }) => {
        try {
            const state = getState();
            const { cart } = state.cartSpace;
            let ids = cart.map(ele=>{
                return ele._id
            })
             
            const response = await fetch(`${apiBaseUrl}/inventoryManagement/getInventoriesOfIds`, {
                method: 'POST',
                credentials:"include",
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ ids:ids }),
            });

            const updatedInventories = await response.json();

            const updatedData = updatedInventories?.data || [];
            const orderedUpdatedInventories = ids
                .map(id => updatedData.find(inv => inv._id === id))
                .filter(inv => inv);

            dispatch(resetCart());
            orderedUpdatedInventories.forEach(updatedInventory => {
                dispatch(addToCart(updatedInventory));
            });
        } catch (error) {
            console.error('Failed to update cart data:', error);
            // Handle error if needed
        }
    }
);
 
 
